module.exports = __webpack_public_path__ + "static/media/menu5.1290eba8.jpg";